import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Bell, ExternalLink, AlertTriangle, AlertCircle, Info, ChevronRight } from 'lucide-react';

const SEV_ICON = {
  high: <AlertTriangle size={14} />,
  medium: <AlertCircle size={14} />,
  low: <Info size={14} />,
  info: <Info size={14} />,
};
const SEV_CLASS = { high: 'alert-high', medium: 'alert-medium', low: 'alert-low', info: 'alert-info' };

export default function AlertBell({ alerts, loading }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const highCount = alerts.filter((a) => a.severity === 'high').length;
  const totalCount = alerts.length;

  return (
    <div className="alert-bell-wrap" ref={ref}>
      <button
        className={`alert-bell-btn ${totalCount > 0 ? 'has-alerts' : ''}`}
        onClick={() => setOpen(!open)}
        title={`${totalCount} alert${totalCount !== 1 ? 's' : ''}`}
      >
        <Bell size={16} />
        {totalCount > 0 && (
          <span className={`alert-bell-badge ${highCount > 0 ? 'alert-badge-high' : ''}`}>
            {totalCount}
          </span>
        )}
      </button>

      {open && (
        <div className="alert-bell-dropdown">
          <div className="alert-bell-header">
            <span>Alerts ({totalCount})</span>
            <Link to="/alerts" className="alert-bell-viewall" onClick={() => setOpen(false)}>
              View all <ChevronRight size={12} />
            </Link>
          </div>
          {loading ? (
            <div className="alert-bell-empty">Loading...</div>
          ) : totalCount === 0 ? (
            <div className="alert-bell-empty">No alerts</div>
          ) : (
            <div className="alert-bell-list">
              {alerts.slice(0, 8).map((a) => (
                <AlertBellItem key={a.id} alert={a} onClose={() => setOpen(false)} />
              ))}
              {totalCount > 8 && (
                <Link to="/alerts" className="alert-bell-more" onClick={() => setOpen(false)}>
                  +{totalCount - 8} more
                </Link>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function AlertBellItem({ alert, onClose }) {
  const content = (
    <div className={`alert-bell-item ${SEV_CLASS[alert.severity]}`}>
      <div className="alert-bell-icon">{SEV_ICON[alert.severity]}</div>
      <div className="alert-bell-body">
        <div className="alert-bell-title">{alert.title}</div>
        <div className="alert-bell-entity">{alert.entity}</div>
      </div>
      <ExternalLink size={10} className="alert-bell-go" />
    </div>
  );

  if (alert.isInternal) {
    return <Link to={alert.action} onClick={onClose} style={{ textDecoration: 'none' }}>{content}</Link>;
  }
  return <a href={alert.action} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>{content}</a>;
}
